<article class="grid-wrapper">
  <ng-template #statusCell>
    <span class="badge rounded-pill text-bg-success">{{ 'common.status.active' | translate }}</span>
  </ng-template>
  @if (loading()) {
  <div class="state-row">
    <div class="spinner-wrapper">
      <app-spinner size="m" type="ripple" />
      <p>{{ 'pages.users.states.loading' | translate }}</p>
    </div>
  </div>
  } @else if (users().length === 0) {
  <div class="state-row">
    <span>{{ 'pages.users.states.empty' | translate }}</span>
  </div>
  } @else {
  <app-responsive-table [items]="users()" [columns]="columns()" [actions]="actions()" [maxInlineActions]="3"
    [trackBy]="trackByUser" (actionSelected)="onActionSelected($event)" [paginated]="true" [page]="pageNumber()"
    [pageSize]="pageSize()" [totalItems]="totalItems()" (pageChange)="onPageChange($event)" />
  }
</article>
